import { render, staticRenderFns } from "./DetailShop.vue?vue&type=template&id=5adea938&scoped=true"
import script from "./DetailShop.vue?vue&type=script&lang=ts"
export * from "./DetailShop.vue?vue&type=script&lang=ts"
import style0 from "./DetailShop.vue?vue&type=style&index=0&id=5adea938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adea938",
  null
  
)

export default component.exports